export default __webpack_public_path__ + "static/media/book1.58c62cf7.png";